import PropTypes, { shape } from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import {
  FnrPopoverOption,
  FnrPopoverOptionIcon,
  FnrPopoverOptionsList,
} from "UI/FnrPopover2";
import { colors } from "UI/colors";

import { Border } from "../StyledComponents";

// started with code copied from Signups/SignupFundSetting/FundButton.js

Dropdown.proptype = {
  nameKey: PropTypes.string.isRequired, // the name of the key for the name/label in the options object
  idKey: PropTypes.string.isRequired, // the name of the key for the id in the options object
  options: PropTypes.arrayOf(
    shape({ name: PropTypes.string, id: PropTypes.number })
  ),
  onSelect: PropTypes.func,
  onClick: PropTypes.func,
  initialSelectedId: PropTypes.number,
  disabled: PropTypes.bool,
};

export default function Dropdown({
  options,
  onSelect,
  nameKey,
  idKey,
  placeholder,
  label,
  initialSelectedId,
  onClick,
  disabled = false,
}) {
  const buttonRef = useRef();
  const [selectedId, setSelectedId] = useState(initialSelectedId);
  const [showMenu, setShowMenu] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  let selectedName = options.find((option) => option[idKey] === selectedId)?.[
    nameKey
  ];

  function toggleMenu() {
    onClick && onClick(showMenu);
    setShowMenu((showMenu) => !showMenu);
  }

  async function handleSelect(option) {
    if (loadingId) return;
    if (option[idKey] === selectedId) return;
    let originalSelectedId = selectedId;

    try {
      setLoadingId(option[idKey]);
      setSelectedId(option[idKey]);
      await onSelect(option[idKey]);
      setLoadingId(null);
      setShowMenu(false);
    } catch (error) {
      setLoadingId(null);
      setSelectedId(originalSelectedId);
    }
  }

  return (
    <>
      <Border padding={"4px 6px 6px 6px"}>
        {label ? <Label>{label}</Label> : null}

        <Button onClick={toggleMenu} ref={buttonRef} disabled={disabled}>
          <ButtonContent>
            {selectedId ? (
              <Value>{selectedName}</Value>
            ) : (
              <Value>{placeholder}</Value>
            )}
            <Icon className="fas fa-chevron-down" flip={showMenu} />
          </ButtonContent>
        </Button>
      </Border>

      <FnrPopoverOptionsList
        show={showMenu}
        onShouldClose={() => setShowMenu(false)}
        buttonRef={buttonRef}
      >
        <OptionsList>
          {options?.map((option) => {
            const isSelected = selectedId && selectedId === option[idKey];

            return (
              <FnrPopoverOption
                key={option[idKey]}
                onClick={() => handleSelect(option)}
                loading={option[idKey] === loadingId}
              >
                <OptionWrapper className="dropdown_option_wrapper">
                  {option[nameKey]}
                  <OptionIcon className={isSelected ? "fas fa-check" : ""} />
                </OptionWrapper>
              </FnrPopoverOption>
            );
          })}
        </OptionsList>
      </FnrPopoverOptionsList>
    </>
  );
}

const Button = styled.button`
  margin-top: 3px;
  background: #f1f4f6;
  border: none;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  border-radius: 6px;
  box-sizing: border-box;

  transition: background-color 250ms;

  &:disabled {
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #daeaf5;
  }
`;

const ButtonContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 2px;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  color: ${colors.fnDkBlueText};
`;

const Value = styled.div`
  /* width: 196px; */
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
`;

const Icon = styled.div`
  transform: rotate(${({ flip }) => (flip ? "180deg" : "0")});
  transition: transform 150ms;
  margin-left: 6px;
`;

const OptionsList = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  /* color: ${colors.fnGray500}; */
  /* letter-spacing: 1px; */
  opacity: 0.5;
  padding: 0 0 0 2px;
  text-transform: uppercase;
  margin-bottom: -1px;
  font-weight: 400;
`;

const OptionWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const OptionIcon = styled.i`
  margin-left: 12px;
  width: 18px;
`;
